'use strict';

module.exports = (function () {
  let TOAST_CONTAINER = null;
  let bottomStickyTimer = null;

  const getContainer = function () {
    return (TOAST_CONTAINER =
      TOAST_CONTAINER ||
      document.getElementById('goods-urgency-toast-container'));
  };

  const setBloodHoundAttributes = function (div, message) {
    div.setAttribute('data-bhc', `toast:goods-urgency-${message.type}`);
    div.setAttribute('data-bhd', JSON.stringify(message.data));
    div.setAttribute('data-bh-viewport', 'respect');
  };

  const createDiv = function (className, message) {
    const div = document.createElement('div');
    //for groupon brand we are showing a color which doesnt exist in the GIG color palette
    div.className = `toast-notification ${className} ${window.I18n.brandId}-new-color`;
    div.className += message.goodsProminentPromoCode
      ? ' prominent-promo-code'
      : '';
    setBloodHoundAttributes(div, message);
    return div;
  };

  const removeDiv = function (div, time_out, delay = 5000) {
    setTimeout(() => {
      const toast = getContainer();
      toast.removeChild(div);
      if (time_out !== null) {
        clearInterval(time_out);
      }
    }, delay);
  };

  const bottomStickyTimerHandler = function () {
    const countDownTimer = document.querySelector(
      '.urgency .text .countdown-timer, .deal-highlights-wrapper .countdown-timer'
    );
    return {
      update(div, message) {
        if (countDownTimer) {
          div.innerHTML = window.I18n.translate(
            `js.modules.goods_urgency_prominence.timer.${message.data.length}`,
            {
              urgencyText: `<strong>${countDownTimer.textContent}</strong>`,
            }
          );
        }
      },
    };
  };

  const setNotificationText = function (div, message) {
    if (message && message.type === 'timer') {
      bottomStickyTimer.update(div, message);
      return setInterval(() => {
        bottomStickyTimer.update(div, message);
      }, 1000);
    } else {
      div.innerHTML = message.text;
    }
    return null;
  };

  const setContainerTextAlignment = function (type) {
    getContainer().style.textAlign = type === 'long' ? 'left' : 'center';
  };

  const createNotification = function (className, message, delay) {
    bottomStickyTimer = bottomStickyTimerHandler();
    const div = createDiv(className, message);
    const time_out = setNotificationText(div, message);
    getContainer().appendChild(div);
    setContainerTextAlignment(message.data.length);
    removeDiv(div, time_out, delay);
  };

  const success = function ({ message, delay }) {
    createNotification('success', message, delay);
  };

  const error = function ({ message, delay }) {
    createNotification('error', message, delay);
  };

  const warning = function ({ message, delay }) {
    createNotification('warning', message, delay);
  };

  const info = function ({ message, delay }) {
    createNotification('info', message, delay);
  };

  return {
    success,
    error,
    warning,
    info,
  };
})();
